export const FTECH_EXTENSION_LISTING            =   'FTECH_EXTENSION_LISTING'
export const FTECH_INDIVIDUAL_EXTENSION_DETAIL  =   "FTECH_INDIVIDUAL_EXTENSION_DETAIL"
export const FETCH_CARD_LISTING                 =   "FETCH_CARD_LISTING"
export const FETCH_PAYMENT_LISTING              =   "FETCH_PAYMENT_LISTING"
export const FETCH_RULE_LISTING                 =   'FETCH_RULE_LISTING' 
export const FETCH_CALL_FLOW_LISTING            =   "FETCH_CALL_FLOW_LISTING"
export const FETCH_IVR_MENU_LISTING             =   "FETCH_IVR_MENU_LISTING"
export const FETCH_BUSINESS_HOUR_LISTING        =   'FETCH_BUSINESS_HOUR_LISTING'
export const FETCH_IVR_GREETING_LISTING         =   'FETCH_IVR_GREETING_LISTING'
export const TIMEZONE_LIST                      =   'TIMEZONE_LIST'